import { DiagnosisItem } from "../../diagnosis.model";
import { Tooth } from "../../../../odontogram/odontogram.model";
import { ItemValidators } from "../../../item-validators";
import { AbstractCondition } from "../condition";

export class RootResorption extends AbstractCondition {
  static validate(
    item: DiagnosisItem,
    odontogram: Tooth[],
    items: DiagnosisItem[],
  ): boolean {
    // validate teeth selected
    if (!ItemValidators.hasTeethSelected(item)) {
      return false;
    }

    // validate not missing
    if (!ItemValidators.notMissingTeeth(item, odontogram)) {
      return false;
    }

    // validate root-resorption option
    if (!ItemValidators.hasOptionSelected(item)) {
      return false;
    }

    return true;
  }

  static apply(odontogram: Tooth[], item: DiagnosisItem): Tooth[] {
    odontogram
      .filter((tooth) => item.teeth.indexOf(tooth.number) > -1)
      .forEach((tooth) => {
        tooth.diagnosis.push({ condition: item.condition });
      });

    return odontogram;
  }

  static getDiagnosis360Changes(item: DiagnosisItem): any {
    return {
      decay_infection: true,
    };
  }

  static supports(condition: string): boolean {
    return condition === "root-resorption";
  }

  static getItemResume(item: DiagnosisItem): any {
    return [
      {
        name: "location",
        value: item.options.options.map(
          (option) => "diagnosis.options." + option,
        ),
      },
    ];
  }

  static getTableData(item: DiagnosisItem): any {
    return [
      "",
      item.options.options.map((option) => "diagnosis.options." + option),
    ];
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/conditions/endodontics/root-resorption.ts